import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import withPersonLayout from '../../layout/withPersonLayout';
import LeaveEmail from '../../container/person/LeaveEmail';
const DashboardComponent = lazy(() => import('../../container/person/Dashboard'));
const TasksManagerComponent = lazy(() => import('../../container/admin/TaskManager'));
const MyTasksComponent = lazy(() => import('../../container/person/MyTasks'));
const ProfileComponent = lazy(() => import('../../components/profile/Profile'));
const ChangePasswordComponent = lazy(() => import('../../components/profile/ChangePassword'));
const TaskDetailsComponent = lazy(() => import('../../container/admin/TaskDetails'));
const ProjectsComponent = lazy(() => import('../../container/admin/Projects'));
const TodoListComponent = lazy(() => import('../../container/admin/TodoList'));
const RequirementsComponent = lazy(() => import('../../components/jira-components/Requirements'));
const UpdateDetailsComponent = lazy(() => import('../../components/profile/UpdateDetails'));
const StatusReport = lazy(() => import('../../container/person/StatusReport'))
const NotFound = lazy(() => import('../../container/pages/404'));

const Person = React.memo(() => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Navigate to="mytasks" />} />
        {/* <Route path="/task-manager" element={<TasksManagerComponent />} /> */}
        <Route path="/mytasks" element={<MyTasksComponent />} />
        {/* <Route path="/projects" element={<ProjectsComponent />} /> */}
        <Route path="/todo" element={<TodoListComponent />} />
        {/* <Route path="/requirements" element={<RequirementsComponent />} /> */}
        {/* <Route path="/leave-management-system" element={<LeaveManagementSystemComponent />} /> */}
        <Route index path="/project-details/:id" element={<TaskDetailsComponent />} />
        <Route index path="/profile/*" element={<ProfileComponent />} />
        <Route index path="/change-password" element={<ChangePasswordComponent />} />
        <Route index path="/update-details" element={<UpdateDetailsComponent />} />
        <Route index path="/statusreport" element={<StatusReport />} />
        <Route index path="/leave" element={<LeaveEmail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withPersonLayout(Person);
